export default "__VITE_ASSET__5c461kLS__"